import { RouterModule, UrlSegment } from "@angular/router";

import { AuthenticatedGuard } from "../shared/index";
import { CreateTaskComponent } from "./create/create-task.component";
import { TasksDetailComponent } from "./detail/tasks-detail.component";
import { TaskTypesComponent } from "./options/task-types.component";
import { NotFoundComponent } from "./not-found/not-found.component";

export function createTaskMatcher(url: UrlSegment[]) {
	const lastSegment = url[url.length - 1];

	if (url.length === 0 || !lastSegment || lastSegment.path !== "create" || url[0].path !== "task") {
		return null;
	}

	const customPath = url
		.slice(1)
		.map((x) => x.path)
		.join("/");
	const customPathSegment = new UrlSegment(customPath, {});

	return {
		consumed: url,
		posParams: {
			path: customPathSegment,
		},
	};
}

export function deeperTaskOptionMatcher(url: UrlSegment[]) {
	const lastSegment = url[url.length - 1];

	if (!lastSegment || lastSegment.path === "create") {
		return null;
	}

	if (url.length === 0 || url[0].path !== "task") {
		return null;
	}

	const customPath = url
		.slice(1)
		.map((x) => x.path)
		.join("/");
	const customPathSegment = new UrlSegment(customPath, {});

	return {
		consumed: url,
		posParams: {
			path: customPathSegment,
		},
	};
}

export const routing = RouterModule.forChild([
	{
		path: ":patient/tasks",
		canActivate: [AuthenticatedGuard],
		children: [
			{ path: "notfound", component: NotFoundComponent },
			{ path: ":id", component: TasksDetailComponent },
		],
	},
	{
		path: ":patient",
		canActivate: [AuthenticatedGuard],
		children: [
			{
				matcher: createTaskMatcher,
				component: CreateTaskComponent,
			},
			{
				matcher: deeperTaskOptionMatcher,
				component: TaskTypesComponent,
			},
		],
	},
]);
